module.exports = __webpack_public_path__ + "media/images/icons/twotone/pound-circle-570ebc20303ff0eab4ad2fb3858d4774.svg";